// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"illustration_wrapper__XJb82","illustration":"illustration_illustration__4_SOU"};